import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import _ from 'lodash';

import Markdown from '../../../components/Markdown';
import Slider from '../../../components/Slider/Slider';
import Image from '../../../components/ContentfulImage';
import media from '../../../styles/media.style';
import { BG_GRAY, TEXT_GRAY, SCREEN_LOCKUP_WIDTH, MOBILE_PADDING } from '../../../styles/variables.style';

const Charts = styled.div`
  margin: 0 auto;
  max-width: ${SCREEN_LOCKUP_WIDTH}px;
  padding: ${MOBILE_PADDING}px;
  width: 100%;

  ${media.tabletL`
    padding: 50px ${MOBILE_PADDING}px;
  `};
`;

const Title = styled.div`
  color: ${TEXT_GRAY.COMMON_5};
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 3em;
  position: relative;
  text-align: center;
  text-transform: uppercase;

  &::after {
    content: '';
    position: absolute;
    bottom: -18px;
    left: 50%;
    transform: translateX(-50%);
    background-color: ${BG_GRAY.COMMON_8};
    height: 3px;
    width: 40px;
  }

  ${media.tabletL`
    margin: 0 0 7em;
  `};
`;

const ColorChartText = styled.div`
  width: 100%;
  font-size: 14px;
  margin-bottom: 30px;
`;
const Slide = styled.div``;

// TODO: マジックナンバーを使用しないこと。
const ColorCharts = ({ copy, data }) => {
  const dataGroup = _.find(data, item => _.pickBy(item, (value, key) => _.startsWith(key, 'entryId')));
  return (
    <Charts id={dataGroup.entryId}>
      <Title>{copy.color_chart}</Title>
      {data && data[0].description && <Markdown src={data[0].description} Component={ColorChartText} />}
      {data && (
        <Slider dots dotsColor="#333" dotsStyle={{ bottom: -50 }}>
          {data.map(image => (
            <Slide key={image.file.assetId}>
              <Image src={image.file} options={{ size: [600, 900, 1060] }} />
            </Slide>
          ))}
        </Slider>
      )}
    </Charts>
  );
};

ColorCharts.defaultProps = {
  copy: {},
  data: undefined,
};

ColorCharts.propTypes = {
  copy: PropTypes.shape(),
  data: PropTypes.arrayOf(PropTypes.shape()),
};

export default ColorCharts;



// WEBPACK FOOTER //
// ./src/pages/RangePage/ColorCharts/ColorCharts.js